import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import { AppBar, DialogContent, Drawer, IconButton, Paper, Toolbar, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPDialog from "app/Core/Components/Dialog/XAPPDialog";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import clsx from "classnames";
import { MdClose } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import CaixaItemCard from "../Components/CaixaItemCard";
import * as Actions from "../Store/Actions/EmpresaFinanceiroActions";
import React from "react";


const styles = theme => ({
    content: {
        "& [class^=\"border-\"]": {
            borderColor: theme.palette.divider
        },
        "& [class*=\"border-\"]": {
            borderColor: theme.palette.divider
        }
    },
    cardSelected: {
        backgroundColor: "#b2b2b2",
        boxShadow: "none"
    },
    painelFiltro: {
        width: "85%",
        "@media (min-width: 1280px)": {
            width: 500,
        }
    },
});

class EmpresaFinanceiroCaixaDialog extends XAPPComponent {

    state = {
        painelFiltro: false,
        preload: false,
    };

    componentDidUpdate(prevProps) {
        const { EmpresaFinanceiro, showMessage, open, openDialog } = this.props;
        if (EmpresaFinanceiro.error) {
            showMessage({
                message: EmpresaFinanceiro.error,
                variant: "error"
            });
            EmpresaFinanceiro.error = null;
        }
        if (EmpresaFinanceiro.warning) {
            showMessage({
                message: EmpresaFinanceiro.warning,
                variant: "warning"
            });
            EmpresaFinanceiro.warning = null;
        }
        if (EmpresaFinanceiro.info) {
            showMessage({
                message: EmpresaFinanceiro.info,
                variant: "success"
            });
            EmpresaFinanceiro.info = null;
        }

        if (prevProps.open === null && this.props.open !== null) {
            this.listItensFilter();
        }

    }

    

    listItensFilter = () => {
        const { xappRouteParams, open } = this.props;
        var AFilter = { AND: [] };
        if (open !== null && open.recebimento !== null) {
            AFilter.AND.push({ Campo: "recebimento", Operador: "=", Valor: open.recebimento });
            AFilter.AND.push({ "Campo": "responsavel", "Operador": "=", "Valor": this.props.responsavel });

            this.props.listCaixaDetalhe(xappRouteParams, AFilter);
            this.setState(_.set({ ...this.state }, "preload", !this.state.preload));
        }
    };

    togglePainelFiltro = () => {
        alert("Implementação pendente");
    };

    getDados = () => {
        const { EmpresaFinanceiro, open } = this.props;

        var AResponse = {};
        AResponse.Dados = [];
        AResponse.Total = { "Geral": 0 };
        AResponse.FormaPagamento = {};

        if (EmpresaFinanceiro.data !== null) {
            if (this.state.preload) {
                this.setState(_.set({ ...this.state }, "preload", !this.state.preload));
            }
            EmpresaFinanceiro.data.forEach(item => {
                if (!_.isUndefined(item.titulos) && !_.isNull(item.titulos)) {
                    item.titulos.forEach(titulo => {
                        if (!_.isNull(titulo.itens)) {
                            titulo.itens.forEach(parcela => {
                                AResponse.Total.Geral += parseFloat(parcela.valor);
                                if (!AResponse.Total[parcela.idpessoaformularioformapagamento]) {
                                    AResponse.Total[parcela.idpessoaformularioformapagamento] = 0;
                                    AResponse.FormaPagamento[parcela.idpessoaformularioformapagamento] = parcela.idpessoaformularioformapagamentodescricao;
                                }
                                AResponse.Total[parcela.idpessoaformularioformapagamento] += parseFloat(parcela.valor);
                            });
                        }
                    });
                }
                var AItem = _.cloneDeep(item);
                AResponse.Dados.push(AItem);
            });
        }

       

        return AResponse;
    };

    render() {
        const { getFilter, open = null, classes, xappRouteParams, saveCaixa, openDialog, isGestor } = this.props;
        const form = this.state;
        const ADados = this.getDados();

        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
        return (
            <XAPPDialog
                id="FinanceiroCaixa"
                open={open !== null}
                onClose={() => openDialog(null)}
                fullWidth
                fullScreen
            >
                <AppBar position="static" elevation={1}>
                    <Toolbar className="flex w-full min-h-0">
                        <Typography variant="subtitle1 text-white">
                            {"CAIXA DO DIA  " + (open !== null && open.recebimento !== null && open.recebimento)}
                        </Typography>
                        <div style={{ flex: 1 }} />
                        <IconButton
                            key="close"
                            aria-label="Close"
                            className="p-6"
                            onClick={() => openDialog(null)}
                        >
                            <MdClose className="text-20 text-white" />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <DialogContent className={classes.content}>
                    <Drawer
                        classes={{ paper: classes.painelFiltro }}
                        open={form.painelFiltro}
                        anchor={"right"}
                        onClose={() => this.togglePainelFiltro()}
                    >
                        <div className="flex">
                            <div className="flex-1" />
                            <XAPPButton
                                className=""
                                onClick={() => this.togglePainelFiltro()}
                                type="icon"
                                icon={"close"}
                                iconProps={"text-20"}
                            />
                        </div>

                    </Drawer>
                    <div className='w-full overflow-hidden'>
                        <div className="flex overflow-x-auto">
                            <Paper className={clsx("w-full rounded-8 border-1 m-8")}>
                                <div className="text-center p-12">
                                    <div className="w-full justify-center items-center flex flex-row mb-12">
                                        <Typography className="text-12 whitespace-no-wrap" color="textSecondary">{"TOTAL"}</Typography>
                                    </div>
                                    <Typography className={"text-20 leading-none"}>{ADados.Total.Geral !== null ? formatter.format(ADados.Total.Geral) : "R$ 0,00"}</Typography>
                                </div>
                            </Paper>
                            {_.filter(Object.keys(ADados.Total), x => x !== "Geral").map((item, x) => (
                                <Paper key={x} className={clsx("w-full rounded-8 border-1 m-8")}>
                                    <div className="text-center p-12">
                                        <div className="w-full justify-center items-center flex flex-row mb-12">
                                            <Typography className="text-12 whitespace-no-wrap" color="textSecondary">{ADados.FormaPagamento[item]}</Typography>
                                        </div>
                                        <Typography className={"text-20 leading-none"}>{formatter.format(ADados.Total[item])}</Typography>
                                    </div>
                                </Paper>
                            ))}
                        </div>
                    </div>
                    {form.preload ?
                        <div className={"w-full items-center flex h-2/3"}>
                            <Loading pastDelay={true} />
                        </div>
                        :
                        ADados.Dados.map((item) => (
                            <CaixaItemCard
                                key={item.idtarefa}
                                data={item}
                                xappRouteParams={xappRouteParams}
                                getFilter={getFilter}
                                listItensFilter={this.listItensFilter}
                                saveCaixa={saveCaixa}
                                isGestor={isGestor}
                                lastItem={ADados.Dados.length === 1}
                                openDialog={openDialog}
                            />
                        ))}
                </DialogContent>
            </XAPPDialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        listCaixaDetalhe: Actions.listCaixaDetalhe,
        saveCaixa: Actions.saveCaixa,
        showMessage: AppActions.showMessage
    }, dispatch);
}

function mapStateToProps({ EmpresaFinanceiro }) {
    return {
        EmpresaFinanceiro: EmpresaFinanceiro,
    };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(EmpresaFinanceiroCaixaDialog)));
